import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostCallsFetchFailedAction = {
	type: 'AI_COST_CALLS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostCallsFetchFailedAction => ({
	type: 'AI_COST_CALLS_FETCH_FAILED',
	payload,
});
